// Confetti voor de 10-10-10 jubileumactie: een feestelijk salvo vanuit de hoek van het actiekaartje,
// een tegensalvo vanuit de andere hoek en een korte regen van boven; alles samen maximaal 4 seconden. Huisstijlkleuren met
// extra goud. Eigen code op één los canvas (geen bibliotheek), ruimt zichzelf op en doet niets bij
// reduced motion.

const KLEUREN = ['#927035', '#c9a874', '#b8893d', '#e8c97a', '#7a5c2a', '#e6d6b8', '#0e1628', '#ffffff', '#d4af37'];
const VORMEN = ['strook', 'strook', 'strook', 'rond', 'ster', 'lint'];

let canvas = null;
let ctx = null;
let deeltjes = [];
let loopt = false;
// Het hele feest duurt maximaal 4 seconden; de laatste 0,6 seconde vervaagt alles.
const MAX_DUUR = 4000;
const UITFADEN = 600;
let einde = 0;

const willekeur = (min, max) => min + Math.random() * (max - min);
const graden = (g) => (g * Math.PI) / 180;
const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function zorgVoorCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    Object.assign(canvas.style, { position: 'fixed', inset: '0', width: '100%', height: '100%', pointerEvents: 'none', zIndex: '95' });
    document.body.appendChild(canvas);
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
}

function nieuwDeeltje(x, y, vx, vy, opties = {}) {
    return {
        x, y, vx, vy,
        vorm: opties.vorm ?? VORMEN[Math.floor(Math.random() * VORMEN.length)],
        maat: willekeur(7, 13) * (opties.schaal ?? 1),
        kleur: KLEUREN[Math.floor(Math.random() * KLEUREN.length)],
        draai: Math.random() * Math.PI * 2,
        draaiSnel: willekeur(-0.25, 0.25),
        wieg: Math.random() * Math.PI * 2,
        wiegSnel: willekeur(0.06, 0.16),
        zwaarte: opties.zwaarte ?? willekeur(0.16, 0.24),
        weerstand: opties.weerstand ?? willekeur(0.975, 0.988),
        leeftijd: 0,
        levensduur: opties.levensduur ?? willekeur(320, 440),
    };
}

function tekenDeeltje(d, vervaag = 1) {
    ctx.save();
    ctx.globalAlpha = Math.max(0, Math.min(1, (d.levensduur - d.leeftijd) / 60)) * vervaag;
    ctx.translate(d.x, d.y);
    ctx.rotate(d.draai);
    ctx.fillStyle = d.kleur;
    ctx.strokeStyle = d.kleur;
    const kantel = Math.abs(Math.cos(d.wieg));
    if (d.vorm === 'rond') {
        ctx.beginPath();
        ctx.ellipse(0, 0, d.maat * 0.45, d.maat * 0.45 * Math.max(0.25, kantel), 0, 0, Math.PI * 2);
        ctx.fill();
    } else if (d.vorm === 'ster') {
        const r = d.maat * 0.62;
        ctx.beginPath();
        for (let i = 0; i < 10; i++) {
            const straal = i % 2 === 0 ? r : r * 0.45;
            const a = (Math.PI / 5) * i - Math.PI / 2;
            ctx.lineTo(Math.cos(a) * straal, Math.sin(a) * straal * Math.max(0.35, kantel));
        }
        ctx.closePath();
        ctx.fill();
    } else if (d.vorm === 'lint') {
        // Een krullend lint: een korte golvende lijn.
        ctx.lineWidth = 2.4;
        ctx.lineCap = 'round';
        ctx.beginPath();
        const lengte = d.maat * 2.4;
        for (let i = 0; i <= 10; i++) {
            const t = i / 10;
            const px = (t - 0.5) * lengte;
            const py = Math.sin(t * Math.PI * 2 + d.wieg) * d.maat * 0.35;
            if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.stroke();
    } else {
        // Platte strookjes die kantelen: de hoogte schommelt mee.
        ctx.fillRect(-d.maat * 0.35, -d.maat * 0.6 * kantel, d.maat * 0.7, d.maat * 1.2 * kantel);
    }
    ctx.restore();
}

function animeer() {
    if (!einde) einde = performance.now() + MAX_DUUR;
    if (loopt) return;
    loopt = true;
    const stap = (nu) => {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (nu >= einde) deeltjes = [];
        ctx.globalAlpha = 1;
        const vervaag = nu > einde - UITFADEN ? Math.max(0, (einde - nu) / UITFADEN) : 1;
        const hoogte = window.innerHeight;
        deeltjes = deeltjes.filter((d) => d.leeftijd < d.levensduur && d.y < hoogte + 40);
        for (const d of deeltjes) {
            d.leeftijd += 1;
            d.vx *= d.weerstand;
            d.vy = d.vy * d.weerstand + d.zwaarte;
            d.wieg += d.wiegSnel;
            d.x += d.vx + Math.sin(d.wieg) * 0.9;
            d.y += d.vy;
            d.draai += d.draaiSnel;
            tekenDeeltje(d, vervaag);
        }
        if (deeltjes.length) {
            requestAnimationFrame(stap);
        } else {
            loopt = false;
            einde = 0;
            canvas.remove();
            canvas = null;
        }
    };
    requestAnimationFrame(stap);
}

// Eén salvo vanuit een punt, in een richting (graden: 0 = rechts, -90 = recht omhoog).
export function schietConfetti(x, y, { aantal = 120, richting = -125, spreiding = 60, kracht = 20 } = {}) {
    if (rustig()) return;
    zorgVoorCanvas();
    for (let i = 0; i < aantal; i++) {
        const hoek = graden(richting + (Math.random() - 0.5) * spreiding);
        const snelheid = kracht * willekeur(0.45, 1.15);
        deeltjes.push(nieuwDeeltje(x, y, Math.cos(hoek) * snelheid, Math.sin(hoek) * snelheid));
    }
    animeer();
}

// Dwarrelende regen van boven over de breedte van het scherm.
export function laatConfettiRegenen({ aantal = 140, duur = 2400 } = {}) {
    if (rustig()) return;
    const breedte = window.innerWidth;
    let gestrooid = 0;
    const perKeer = 3;
    const strooi = () => {
        zorgVoorCanvas();
        for (let i = 0; i < perKeer && gestrooid < aantal; i++, gestrooid++) {
            deeltjes.push(nieuwDeeltje(willekeur(0, 1) * breedte, willekeur(-40, -10), willekeur(-1.2, 1.2), willekeur(4, 7), {
                zwaarte: willekeur(0.11, 0.16),
                weerstand: 0.99,
                levensduur: willekeur(200, 260),
                schaal: willekeur(0.8, 1.15),
            }));
        }
        animeer();
        if (gestrooid < aantal) setTimeout(strooi, (duur / aantal) * perKeer);
    };
    strooi();
}

// Het hele feestmoment: drie salvo's uit de hoek, een tegensalvo uit de andere hoek en een regen.
export function vierFeest(x, y, { smal = false } = {}) {
    if (rustig()) return;
    const hoogte = window.innerHeight;
    const breedte = window.innerWidth;
    const salvo = (vertraging, opties) => setTimeout(() => schietConfetti(x, y, opties), vertraging);
    salvo(0, { aantal: smal ? 90 : 150, richting: smal ? -105 : -128, spreiding: 62, kracht: smal ? 19 : 24 });
    salvo(180, { aantal: smal ? 70 : 120, richting: smal ? -95 : -112, spreiding: 50, kracht: smal ? 21 : 27 });
    salvo(360, { aantal: smal ? 60 : 110, richting: smal ? -120 : -145, spreiding: 70, kracht: smal ? 17 : 22 });
    // Tegensalvo vanuit de linkeronderhoek, schuin omhoog naar rechts.
    setTimeout(() => schietConfetti(smal ? breedte * 0.06 : 24, hoogte - (smal ? 110 : 24), {
        aantal: smal ? 70 : 130, richting: smal ? -75 : -55, spreiding: 50, kracht: smal ? 20 : 25,
    }), 450);
    // En daarna dwarrelt het nog even na, van boven.
    setTimeout(() => laatConfettiRegenen({ aantal: smal ? 90 : 170, duur: 1200 }), 600);
}

// Ritme: één keer confetti, dan tien keer niet, dan weer één keer. Er telt alleen een moment waarop de
// confetti zou kunnen afgaan (het actiekaartje of de actieregel komt in beeld). De teller staat in de
// browser (localStorage), dus het ritme loopt door over pagina's en bezoeken heen.
const SLEUTEL = 'renoco-confetti-teller';
const OVERSLAAN = 10;

function magNu() {
    try {
        const teller = parseInt(localStorage.getItem(SLEUTEL) || '0', 10) || 0;
        localStorage.setItem(SLEUTEL, String((teller + 1) % (OVERSLAAN + 1)));
        return teller === 0;
    } catch (e) {
        // Zonder opslag: hooguit één keer per pagina-sessie.
        if (window.__renocoConfetti) return false;
        window.__renocoConfetti = true;
        return true;
    }
}

// Alleen tijdens de actie (niet bij de aankondiging), zodra het actiekaartje rechtsonder in beeld schuift
// (desktop) of de bronzen actieregel boven de contactbalk zichtbaar is (telefoon).
export default function maakActieConfetti() {
    if (window.renocoTijd?.fase !== 'actief' || rustig()) return;

    let klaar = false;
    const probeer = () => {
        if (klaar || window.scrollY < window.innerHeight * 0.9) return;

        // Het kaartje bestaat op desktop al (onzichtbaar) en schuift bij deze scroll in beeld.
        const kaart = document.querySelector('.actie-zwevend:not([hidden])');
        const regel = document.querySelector('.contactbalk__actie:not([hidden])');
        // offsetParent is altijd null bij een vast (fixed) element; kijk daarom naar de weergave zelf.
        const zichtbaar = (el) => el && getComputedStyle(el).display !== 'none' && el.getClientRects().length > 0;
        const doel = zichtbaar(kaart) ? kaart : (zichtbaar(regel) ? regel : null);
        if (!doel) return;

        klaar = true;
        window.removeEventListener('scroll', probeer);
        if (!magNu()) return;

        // Wacht tot het kaartje is ingeschoven, en vier dan feest vanuit de linkerbovenhoek ervan.
        setTimeout(() => {
            const r = doel.getBoundingClientRect();
            const smal = window.innerWidth < 640;
            vierFeest(r.left + (smal ? r.width * 0.85 : 16), r.top + 4, { smal });
        }, doel === kaart ? 520 : 150);
    };

    window.addEventListener('scroll', probeer, { passive: true });
}
